import { Component } from 'react'
import { FileDropZone } from 'components/features/pfm/FileDropZone/FileDropZone'
import { MapDispatchToPropsFunction, connect } from 'react-redux'
import { ComposeId } from 'interfaces/feed'
import { feedComposeFetchLinkActionCreator, feedComposeAddImageAttemptActionCreator } from 'actions/feedComposeActions'
import { State } from 'interfaces/state'

type FeedDropZoneStateProps = {
  composeId: ComposeId | null
}

type FeedDropZoneDispatchProps = {
  addImages: (file: File[], composeId: ComposeId) => void
  fetchLink: (url: string, composeId: ComposeId) => void
}

type FeedDropZoneOwnProps = {
}

type FeedDropZoneProps =
  & FeedDropZoneStateProps
  & FeedDropZoneDispatchProps
  & FeedDropZoneOwnProps

class FeedDropZoneComponent extends Component<FeedDropZoneProps> {
  render () {
    const { children } = this.props

    return (
      <FileDropZone
        onFiles={ this.handleFiles }
        onUrl={ this.handleUrl }
      >
        { children }
      </FileDropZone>
    )
  }

  private handleFiles = (files: File[]) => {
    const { composeId, addImages } = this.props
    if (!composeId) {
      return
    }
    addImages(files, composeId)
  }

  private handleUrl = (url: string) => {
    const { composeId, fetchLink } = this.props
    if (!composeId) {
      return
    }
    fetchLink(url, composeId)
  }
}

const mapStateToProps = (state: State) => {
  const { composes, composeLastFocus } = state.app.feed
  const compose = composes.byKey[composeLastFocus]

  return {
    composeId: compose && compose.isExists ? composeLastFocus : null,
  }
}

const mapDispatchToProps: MapDispatchToPropsFunction<FeedDropZoneDispatchProps, FeedDropZoneOwnProps> =
  (dispatch) => ({
    addImages: (files, composeId) => dispatch(feedComposeAddImageAttemptActionCreator.request({ files, composeId })),
    fetchLink: (url, composeId) => dispatch(feedComposeFetchLinkActionCreator.request({ url, composeId })),
  })

export const FeedDropZone = connect<
  FeedDropZoneStateProps,
  FeedDropZoneDispatchProps,
  FeedDropZoneOwnProps
>(mapStateToProps, mapDispatchToProps)(FeedDropZoneComponent)
